export const validate = (error = {}) => {
  let valid = true;

  Object.keys(error).forEach((key) => {
    if (error[key]) valid = false;
  });

  return valid;
};
